<div class="table">
  <div class="row header">
    <div class="column mini">Belopp</div>
    <div class="column mini">Amortering</div>
    <div class="column mini">Ränta</div>
    <div class="column mini">Månadskostnad</div>
    <div class="center column mini">Belåningsobjekt</div>
  </div>
  @for (loan of this.kalpylator().loans; track loan) {
    <div class="row">
      <div class="column">{{ loan.amount | number: '1.0-0' : 'sv' }}</div>
      <div class="column">{{ loan.mortgage | number: '1.0-0' : 'sv' }}</div>
      <div class="column">{{ loan.monthlyInterest | number: '1.0-0' : 'sv' }}</div>
      <div class="column">{{ loan.monthlyCost | number: '1.0-0' : 'sv' }}</div>
      <div class="column center">
        @if (loan.new) {
          <mat-icon class="center positive">check</mat-icon>
        }
      </div>
    </div>
  }
  <div class="row">
    <div class="column sum">Totalt för Lån</div>
    <div class="column">{{ kalpylator().monthlyLoanMortgage | number: '1.0-0' : 'sv' }}</div>
    <div class="column">{{ kalpylator().monthlyLoanInterest | number: '1.0-0' : 'sv' }}
    </div>
    <div
      class="column">{{ kalpylator().monthlyLoanCost | number: '1.0-0' : 'sv' }}
      <sup>*</sup></div>
    <div class="column"></div>
  </div>

  <div><sup>*</sup>
    Avdraget {{ kalpylator().monthlyLoanTaxReturn | number:'1.0-0': 'sv' }}
    i skattereduktion.
  </div>
  <div class="copy-to-right">
    <spb-copy [copy]="copy"></spb-copy>
  </div>
</div>
